import OSS from 'ali-oss'
import { getAssumeRole } from '../api/request'

const SessionKey = 'AliyunAssumeRole'
const TokenRefreshInterval = 3600*1000
const OssOptions = {
    // 填写Bucket名称，例如examplebucket。
    bucket: '',
    // oss region domain. It takes priority over region. Set as extranet domain name, intranet domain name, accelerated domain name, etc.
    endpoint: '',    
    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    accessKeyId: '',
    accessKeySecret: '',
    // 从STS服务获取的安全令牌（SecurityToken）。
    stsToken: '',
    // 向您搭建的STS服务获取临时访问凭证。
    refreshSTSToken: getCredentials,
    // 刷新临时访问凭证的时间间隔，单位为毫秒。
    refreshSTSTokenInterval: TokenRefreshInterval,
    // instruct OSS client to use HTTPS (secure: true) or HTTP (secure: false) protocol.
    secure: true
}

async function getCredentials() {
    try {
        const sessionVal = window.sessionStorage.getItem(SessionKey)
        if (sessionVal) {
            const data = JSON.parse(sessionVal)
            // 若Token过期时间在下次刷新时间之后，则直接返回缓存值
            if (Date.parse(data.expiration) - Date.now() > TokenRefreshInterval) {
                return _convertCredentials(data)
            }
        }
        const res = await getAssumeRole()
        if (res.success && res.data && res.data.expiration) {
            window.sessionStorage.setItem(SessionKey, JSON.stringify(res.data))
            return _convertCredentials(res.data)
        }
    } catch(err) {
        console.log(`getCredentials error: ${err.message}`)
    }
    return _convertCredentials()
}

function _convertCredentials(data) {
    return {
        accessKeyId: data && data.accessKeyId ? data.accessKeyId : '',
        accessKeySecret: data && data.accessKeySecret ? data.accessKeySecret : '',
        stsToken: data && data.securityToken ? data.securityToken : ''
    }
}

export default async function initClient() {
    try {
        const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
        OssOptions.bucket = userInfo.publicBucket
        OssOptions.endpoint = userInfo.publicEndpoint
        await getCredentials()
        const credentials = JSON.parse(window.sessionStorage.getItem(SessionKey))
        OssOptions.accessKeyId = credentials.accessKeyId
        OssOptions.accessKeySecret = credentials.accessKeySecret
        OssOptions.stsToken = credentials.securityToken
        return new OSS(OssOptions)
    } catch(err) {
        console.log(`initClient error: ${err.message}`)
    }
    return null
}